export default __webpack_public_path__ + "static/media/Acquisition in Serentica Renewables India 33 Pvt Ltd.3f4333b1.pdf";